import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Section, sectionSpacingY } from "components/section";
import { TextLarge } from "ui/text";
import { TreeAnimation } from "./tree-animation";

export function IntroParagraph() {
  return (
    <Section my={0} py={sectionSpacingY}>
      <TextLarge
        maxW="4xl"
        size="lg"
        textAs="h2"
        text={
          <>
            If AI has changed everything, <Box as="br" display={{ base: "none", md: "block" }} />
            <Text as="span" color="new.violet.700">
              why is marketing the same?
            </Text>
          </>
        }
      />

      <Flex gap="biggest" pos="relative">
        <Flex
          color="brand.textSecondary.light"
          flexDir="column"
          gap="small"
          textStyle={{ base: "body3", md: "body2" }}
          mt={{ base: "bigger", md: "biggest" }}
          maxW={{ base: "100%", lg: "55%" }}
        >
          <Text>
            Right now, as you read this, a fleet of robot taxis is shuttling passengers across San Francisco and an AI
            can plan your vacation or proof-read your novel.
          </Text>

          <Text>
            So,{" "}
            <Text as="strong" fontWeight="bold">
              then why do we still send e-mails, SMS, and push like it’s 2003?
            </Text>
          </Text>

          <Text>
            AI Decisioning uses machine learning and automated experimentation to remove the guesswork of manual
            segmentation, content planning, and A/B testing. It uses all your data to determine and deliver optimal
            marketing for every customer.
          </Text>

          <Text>
            The result? A higher impact program that contributes more revenue and delivers a better customer experience.
          </Text>
        </Flex>

        <TreeAnimation
          display={{ base: "none", lg: "flex" }}
          flex={0.5}
          color="new.violet.500"
          pos="absolute"
          right={0}
          width="34%"
          bottom="tiny"
        />
      </Flex>
    </Section>
  );
}
